export const PLAN_SETUP_FIELD = {
  PLAN_TEMPLATE_NAME: 'planTemplateName',
  PLAN_NAME: 'planName',
  PLAN_NOTES: 'planNotes',
  PLAN_SUMMARY: 'planSummary',
  PLAN_TEMPLATE: 'planTemplate',
  PLAN_TYPE: 'planType',
  PARENT_TEMPLATE: 'parentTemplate',
  PLAN_CODE: 'planCode',
  PRIOR_PLAN_ID: 'priorPlanId',
  PLAN_YEAR: 'planYear',
  MAXIMUM_ELECTION_AMOUNT_CUSTOM: 'maximumElectionAmountCustom',
  MAXIMUM_ELECTION_AMOUNT_IRS: 'maximumElectionAmountIRS',
  MINIMUM_ELECTION_AMOUNT_CUSTOM: 'minimumElectionAmountCustom',
  PROOF_OF_EXPENSE: 'proofOfExpense',
  PROOF_OF_EXPENSES_CARD_TYPE: 'proofOfExpensesCardType',
  GENERATE_STATEMENTS: 'generateStatements',
  IGNORE_ELECTION_LIMIT: 'ignoreElectionLimit',
  PLAN_LEVEL_FUNDING: 'planLevelFunding',
  REPLENISHMENT_BANK_ACCOUNT: 'replenishmentBankAccount',
  REPLENISHMENT_FREQUENCY: 'replenishmentFrequency',
  REPLENISHMENT_METHOD: 'replenishmentMethod',
  REPLENISHMENT_DAY_NUMBER: 'replenishmentDayNumber',
  AI_ADJUDICATION_TYPE: 'aiAdjudicationType',
  SPEND_LIMIT: 'spendLimit',
  SPEND_PERIOD: 'spendPeriod',
  PER_PERSON_SPEND_LIMIT: 'perPersonSpendLimit',
  PER_PERSON_SPEND_LIMIT_AMOUNT: 'perPersonSpendLimitAmount',
  SPEND_LIMIT_IRS_AMOUNT: 'spendLimitIRSAmount',
  SPEND_LIMIT_CUSTOM: 'spendLimitCustom',
  TOTAL_PLAN_LIMIT: 'totalPlanLimit',
  TOTAL_PLAN_LIMIT_TYPE: 'totalPlanLimitType',
  PER_CATEGORY_SPEND_LIMIT: 'perCategorySpendLimit',
  IS_PRE_FUND_CALCULATED: 'isPreFundCalculated',
  REPLENISHMENT_PERCENT: 'replenishmentPercent',
  REPLENISHMENT_MIN_VALUE: 'replenishmentMinValue',
  REPLENISHMENT_CREEP_PERCENT: 'replenishmentCreepPercent',
  REPLENISHMENT_CREEP_MIN: 'replenishmentCreepMin',
  REPLENISHMENT_PERCENT_SPENDDOWN: 'replenishmentPercentSpenddown',
  AVAILABLE_BALANCE: 'availableBalance',
  MAXIMUM_ELECTION_AMOUNT: 'maximumElectionAmount',
  MINIMUM_ELECTION_AMOUNT: 'minimumElectionAmount',
  CIP_ACCOUNT_CLOSURE_DELAY_DAYS: 'CIPAccountClosureDelayDays',
  RETURN_FUNDS_AFTER_CIP_ACCOUNT_CLOSURE_TYPE: 'returnFundsAfterCipAccountClosureType',
  CARD_OFFERED: 'cardOffered',

  FUND_ID_FOMRULA: 'fundIDFormula',

  OMNIBUS: 'omnibus',
  ACCOUNT_CREATION: 'accountCreation',
  CMS_REPORTING_REQUIRED: 'CMSReportingRequired',

  GRACE_PERIOD: 'gracePeriod',
  ALLOW_INDIVIDUAL_CONTRIBUTIONS: 'allowIndividualContributions',
  CONTRIBUTION_MONITORING_REQUIRED: 'contributionMonitoringRequired',
  IS_ALLOW_CONTRIBUTIONS_OVER_ELECTION_AMOUNT: 'isAllowContributionsOverElectionAmount',
  ALLOW_CONTRIBUTION_AFTER_ACCOUNT_CLOSURE: 'allowContributionAfterAccountClosure',
  MINIMUM_CONTRIBUTION_AMOUNT: 'minimumContributionAmount',

  IS_PARTICIPANT_PAID_MAINTENANCE_FEE: 'isParticipantPaidMaintenanceFee',
  IS_FORFEIT_ALLOWED: 'isForfeitAllowed',
  FORFEITURE_DAYS: 'forfeitureDays',
  MAINTENANCE_FEE: 'maintenanceFee',
  APPLY_FEE_TO: 'applyFeeTo',
  CASH_BALANCE_TRESHOLD: 'cashBalanceThreshold',
  FUNDING_METHOD: 'fundingMethod',
  EOY_PLAN_RECONCILIATION: 'eoyPlanReconciliation',
  EOY_PLAN_RECONCILIATION_DELAY_DAYS: 'eoyPlanReconciliationDelayDays',
  BILLING_METHOD_TYPE_ID: 'billingMethodTypeId',
  EXTERNAL_BANK_ACCOUNT: 'externalBankAccount',
  ACCOUNT_TO_PUSH_TO: 'accountToPushTo',
  EXTERNAL_PUSH_RETURN_ACCOUNT: 'externalPushReturnAccount',

  CONTRIBUTION_HOLD_PERIOD: 'contributionHoldPeriod',
  CONTRIBUTION_PUSH_GIVE_UP_DAYS: 'contributionPushGiveUpDays',

  INCLUDE_TO_BALANCE_REMINDER: 'includeToBalanceReminder',
  PEND_CONTRIBUTIONS_FOR_CIP: 'pendContributionsForCIP',
  MINIMUM_INVESTMENT_AMOUNT: 'minimumInvestmentAmount',
  INVESTMENT_THRESHOLD: 'investmentThreshold',
};

export enum OmnibusKeys {
  HSA = 'HSA',
  NOTIONAL = 'NOTIONAL',
}

export enum IrsLimitTypesLabel {
  HCFSA_MAX = 'HCFSA max',
  HCFSA_EE_ER_MAX = 'HCFSA EE + ER max',
  HSA_MAX = 'HSA max',
  DCAP_MAX = 'DCAP max',
  TRANSIT_MAX = 'Transit max',
  PARKING_MAX = 'Parking max',
}

export const REQUIRED_TYPE = 'required';

export const FIRST_PLAN_KEY = 'FIRST_PLAN';
export const FIRST_PLAN_YEAR_KEY = 'FIRST_PLAN_YEAR';

export const FIRST_PLAN_OPTION = {
  key: FIRST_PLAN_KEY,
  value: 'No prior plan',
  title: 'No prior plan',
};

export const NO_PRIOR_PLAN_YEAR_OPTION = {
  key: FIRST_PLAN_YEAR_KEY,
  value: 'No prior plan year',
  title: 'No prior plan year',
};

export const FIRST_PLAN_DIVIDER = {
  divide: true,
  isGroupDivider: true,
  groupKey: 'priorPlans',
  groupDividerTitle: '',
};
